// Демо-данные окна «Подключение почты» для главной Hub.
// kind: oauth — авторизация у провайдера (Google, Microsoft), imap — адрес, пароль приложения и серверы IMAP/SMTP.
// hosts — предзаполненные серверы для популярных провайдеров, чтобы не искать их вручную.
import { t } from "@/lib/i18n";

export const emailCategories = [
  { id: "all", label: t("Все провайдеры"), icon: "ri-apps-2-line" },
  { id: "corporate", label: t("Корпоративные"), icon: "ri-building-4-line" },
  { id: "personal", label: t("Личные"), icon: "ri-mail-line" },
  { id: "custom", label: t("Свой сервер"), icon: "ri-server-line" },
];

export const emailProviders = [
  {
    id: "google-workspace",
    name: "Google Workspace",
    description: t("Почта на домене компании: письма клиентов и коллег попадают в общую ленту Hub."),
    category: "corporate",
    icon: "ri-google-fill",
    badge: t("Популярный"),
    kind: "oauth",
    authLabel: t("Открыть Google"),
    sample: "team@company.ru",
    connected: false,
    account: "",
    unread: 0,
    permissions: [
      t("Читать входящие и отправленные письма"),
      t("Отправлять ответы от имени ящика"),
      t("Видеть адрес и имя отправителя"),
    ],
  },
  {
    id: "gmail",
    name: "Gmail",
    description: t("Личный или рабочий ящик Gmail: переписка с клиентами рядом с WhatsApp и Telegram."),
    category: "personal",
    icon: "ri-mail-fill",
    kind: "oauth",
    authLabel: t("Открыть Google"),
    sample: "sales@gmail.com",
    connected: true,
    account: "sales@hub-market.ru",
    unread: 3,
    permissions: [t("Читать входящие и отправленные письма"), t("Отправлять ответы от имени ящика")],
  },
  {
    id: "yandex",
    name: t("Яндекс Почта"),
    description: t("Ящик на Яндексе для бизнеса: серверы уже прописаны, нужен только пароль приложения."),
    category: "personal",
    icon: "ri-mail-open-line",
    badge: t("Быстрый старт"),
    kind: "imap",
    sample: "sales@yandex.ru",
    connected: false,
    account: "",
    unread: 0,
    permissions: [],
    hosts: { imap: "imap.yandex.ru", imapPort: "993", smtp: "smtp.yandex.ru", smtpPort: "465" },
  },
  {
    id: "outlook",
    name: t("Microsoft 365 и Outlook"),
    description: t("Рабочая почта Microsoft: общий ящик отдела продаж и отдельные адреса менеджеров."),
    category: "corporate",
    icon: "ri-windows-fill",
    kind: "oauth",
    authLabel: t("Открыть Microsoft"),
    sample: "sales@company.ru",
    connected: false,
    account: "",
    unread: 0,
    permissions: [
      t("Читать входящие и отправленные письма"),
      t("Отправлять ответы от имени ящика"),
      t("Видеть календарь встреч с клиентом"),
    ],
  },
  {
    id: "mailru",
    name: "Mail.ru",
    description: t("Почта Mail.ru с паролем приложения: письма превращаются в диалоги с историей."),
    category: "personal",
    icon: "ri-at-line",
    kind: "imap",
    sample: "sales@mail.ru",
    connected: false,
    account: "",
    unread: 0,
    permissions: [],
    hosts: { imap: "imap.mail.ru", imapPort: "993", smtp: "smtp.mail.ru", smtpPort: "465" },
  },
  {
    id: "custom",
    name: t("Другая почта по IMAP"),
    description: t("Свой почтовый сервер, корпоративный домен или хостинг: подключение по IMAP и SMTP."),
    category: "custom",
    icon: "ri-server-line",
    kind: "imap",
    sample: "info@your-domain.ru",
    connected: false,
    account: "",
    unread: 0,
    permissions: [],
    hosts: { imap: "", imapPort: "993", smtp: "", smtpPort: "465" },
  },
];